import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    title: {
        fontSize: '2.2rem',
        fontWeight: 500,
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginBottom: '1rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '1.3rem',
            marginBottom: '0.5rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2.8rem',
        },
    },
    category: {
        color: theme.palette.primary.main,
        fontSize: '1.3rem',
        fontWeight: 600,
        marginTop: '10px',
        marginBottom: '10px',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '1rem',
            marginBottom: '8px',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '1.4rem',
        },
    },
    eventTime: {
        marginTop: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginBottom: '1rem',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginBottom: '8px',
        },
    },
    eventTimeIcon: {
        width: '15px',
        marginRight: '5px',
    },
    eventTimeText: {
        color: theme.palette.secondary.main,
        fontWeight: 600,
        fontSize: '1.2rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '1rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '1.3rem',
        },
    },
}));
